<template lang="pug">
.utility-view(:class='value.type')
  .type
    i.mi {{ICON_SET[value.type] || ''}}
    span {{$formatters.utility_label(value.type)}}
  .mechanical(v-if='manual_meter')
    .sub 上次结算
    span(v-if='this.paid[value.type]') {{this.paid[value.type]}} {{$formatters.utility_unit(value.type)}}
    span(v-else) -
  .balance
    .pre-text(v-if='manual_meter') 已使用
    span {{balance}}
    .unit {{$formatters.utility_unit(value.type)}}
  .mechanical
    .sub 机械表
    span(v-if='value.mechanical') {{value.mechanical}} {{$formatters.utility_unit(value.type)}}
    span(v-else) -
  .time
    .sub 上次抄表
    span {{$formatters.date.from_now(value.time_last_check)}}
</template>

<script>
const ICON_SET = {
  water: 'opacity',
  hot_water: 'invert_colors',
  electricity: 'flash_on',
  kitchen: 'local_dining',
}

export default {
  name: 'utility-view',
  props: {
    data: { type: Object, default: {} },
    paid: { type: Object, default: {} },
    fallback: { type: Object },
  },
  data() {
    return {
      ICON_SET,
      manual_meter: this.$config.logic.manual_meter,
    }
  },
  computed: {
    value() {
      if (!this.data.mechanical && this.fallback)
        return this.fallback
      return this.data
    },
    balance() {
      if (this.manual_meter)
        return (this.value.mechanical - (this.paid[this.value.type] || 0)).toFixed(1)

      return this.value.balance.toFixed(1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// UtilityView.vue?45ae615a